export const IGetTipStateUseCaseType = Symbol('IGetTipStateUseCase');
